/**
 * DesktopShell: purely decorative editorial backdrop shown only on large screens.
 * The mobile-first app column (max-w-md) sits centered on top; this fills the
 * surrounding void with warm editorial context. Hidden below `lg`.
 */
export default function DesktopShell() {
  return (
    <div
      aria-hidden="true"
      className="hidden lg:block fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
    >
      {/* Warm editorial backdrop */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_10%,rgba(107, 122, 84,0.10),transparent_55%),radial-gradient(ellipse_at_85%_85%,rgba(107, 122, 84,0.07),transparent_50%),linear-gradient(180deg,#ECE7DF_0%,#DDD5CB_100%)]" />

      {/* Central "device" column silhouette — matches max-w-md mobile column */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-md h-full bg-[#FBF9F6] border-x border-stone-200/70 shadow-[0_0_80px_rgba(28,25,23,0.10)]" />

      {/* Left editorial panel */}
      <div className="absolute left-0 top-0 h-full flex items-center pl-12 xl:pl-20 pointer-events-none">
        <div className="max-w-sm">
          <img src="/aynora-logo.png" alt="Aynora" className="w-28 h-28 rounded-2xl shadow-[0_16px_40px_rgba(107,122,84,0.2)] mb-8" />
          <div className="text-[10px] font-[Manrope] font-bold tracking-[0.4em] uppercase text-[#6B7A54]/80 mb-2">
            Aynora
          </div>
          <div className="text-[10px] font-[Manrope] tracking-[0.35em] uppercase text-stone-500/80 mb-6">
            Mirror of Light
          </div>
          <h2 className="font-[Cormorant_Garamond] text-6xl xl:text-7xl leading-[1.02] text-stone-900/85 tracking-tight">
            The stylist<br />who <em className="italic text-[#6B7A54]/90">remembers.</em>
          </h2>
          <p className="mt-8 font-[Manrope] text-sm text-stone-600/80 leading-relaxed max-w-xs">
            A personal wardrobe consultant that knows what you own, what you wore,
            and who you were meeting. Editorial thinking, in your pocket.
          </p>

          <div className="mt-14 flex items-center gap-4">
            <span className="h-px w-16 bg-stone-400/50" />
            <span className="text-[10px] font-[Manrope] font-bold tracking-[0.35em] uppercase text-stone-500/80">
              Volume 01 · SS 26
            </span>
          </div>
        </div>
      </div>

      {/* Right editorial panel */}
      <div className="absolute right-0 top-0 h-full flex items-center justify-end pr-12 xl:pr-20 pointer-events-none">
        <div className="max-w-xs text-right">
          <div className="text-[10px] font-[Manrope] font-bold tracking-[0.4em] uppercase text-stone-500/70 mb-6">
            An editorial note
          </div>
          <p className="font-[Cormorant_Garamond] text-3xl xl:text-4xl italic text-stone-700/85 leading-[1.15]">
            &ldquo;Fashion fades.<br />Only style remains<br />the same.&rdquo;
          </p>
          <p className="mt-4 font-[Manrope] text-xs tracking-[0.2em] uppercase text-stone-500/70">
            — Coco Chanel
          </p>

          <div className="mt-16 flex items-center justify-end gap-4">
            <span className="text-[10px] font-[Manrope] font-bold tracking-[0.35em] uppercase text-stone-500/80">
              Best on mobile
            </span>
            <span className="h-px w-16 bg-stone-400/50" />
          </div>
        </div>
      </div>
    </div>
  );
}
